import React from "react";
import { LocaleKey, useFormatMessage } from "../../utils/intlHelpers";
import styles from "./styles.module.scss";

export const AppFooter = () => {
  const formatMessage = useFormatMessage();

  return (
    <footer className={styles.footer}>
      <div className={styles.topSection} />
      <div className={styles.footerCopyright}>
        <div className={`test-id-copyright ${styles.copyright}`}>
          <span>{`${formatMessage(
            "common.copyrightSymbol" as LocaleKey
          )} ${new Date().getFullYear()} ${formatMessage(
            "common.apexClearingCorp" as LocaleKey
          )}`}</span>
        </div>
        <div>
          {formatMessage("common.footer.member" as LocaleKey)} |{" "}
          <span className="app-version">
            ver {process.env.REACT_APP_VERSION}
          </span>
        </div>
      </div>
    </footer>
  );
};
